import { motionValue, type MotionValue } from 'framer-motion';
import type { AudioBands } from '../types';

// packages/lyric-stage/src/host/createAudioBands.ts

const EMPTY_SPECTRUM: Uint8Array<ArrayBuffer> = new Uint8Array(new ArrayBuffer(0));

export const createEmptyAudioBands = (): {
  audioPower: MotionValue<number>;
  audioBands: AudioBands;
} => {
  const audioPower = motionValue(0);
  const audioBands: AudioBands = {
    bass: motionValue(0),
    lowMid: motionValue(0),
    mid: motionValue(0),
    vocal: motionValue(0),
    treble: motionValue(0),
    spectrum: motionValue(EMPTY_SPECTRUM),
  };
  return { audioPower, audioBands };
};
